<a (click)="onClick.emit()" [routerLink]="item.url" routerLinkActive="active-link"
  class="flex items-center justify-between rounded-lg py-2 px-3 text-sm font-medium text-gray-700 md:hover:bg-slate-500/5 md:hover:text-gray-900 transition-colors cursor-pointer w-full">
  <div class="flex items-center gap-2">
    <ng-icon [class.active-icon]="isTheCurrentUrlActive()" [size]="'17px'" [name]="item.icon" class="h-5 w-5 icon"></ng-icon>
    <span>{{ item.name }}</span>
  </div>
</a>

